import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { User } from '../shared/auth/user';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class DataStorageService {
  public isOnline:Boolean;
  isOnlineData=new BehaviorSubject<Boolean>(this.isOnline);
  isonline$=this.isOnlineData.asObservable();

  public ekpay_id: string;
  ekpayData = new BehaviorSubject<string>(this.ekpay_id);
  ekpayId$ = this.ekpayData.asObservable();

  public storage: any;
  public isDataAvailable: boolean;
  public user: User;
  userDataService = new BehaviorSubject<User>(this.user);

  public lang:string;
  langData=new BehaviorSubject<string>(this.lang);
  langData$=this.langData.asObservable();

  public tab:string;
   tabData=new BehaviorSubject<string>(this.tab);
   tabData$=this.tabData.asObservable();

  dataSource = new BehaviorSubject<boolean>(this.isDataAvailable);

  userData$ = this.userDataService.asObservable();

  dataAvail = this.dataSource.asObservable();
  comp_id:string;
  ticket_id:string;
  dispute_id:string;
  direct_dis_id:string;

   httpStatus:any;
   httpMessage:any;
  @Output() fire: EventEmitter<any> = new EventEmitter();

  constructor(private logger: NGXLogger) {
    //this.logger.debug('called..');
   }
  get isEmpty(): boolean {
    return this.storage === null || this.storage === undefined;
  }


  setUserData(user: User) {
    this.userDataService.next(user);
  }
  setekpayid(ekpayId: string) {
    this.ekpayData.next(ekpayId);
  }

  setTabData(data:string){
    this.tabData.next(data);
  }

  setLangData(Lang:string){
    this.langData.next(Lang);
  }

  setOnline(isonline:Boolean){
    this.isOnlineData.next(isonline);
  }

  setHttpStatus(httpStatus:any){
    this.httpStatus=httpStatus;
  }

  getHttpStatus(){
    return this.httpStatus;
  }

  setHttpMessage(httpMessage:any){
    this.httpMessage=httpMessage;
  }

  getHttpMessage(){
    return this.httpMessage;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-storage.service.ts